
export default function httpStatus(code, redirect) {
  this.type = 'httpStatusException';
  this.code = code;
  this.redirect = redirect;
}
